import { NgModule } from "@angular/core";
import { AsyncPipe, CommonModule, DatePipe } from "@angular/common";
import { NgxStripeModule } from "ngx-stripe";
import { RouterModule } from "@angular/router";
import { RecruiterComponentRoutingModule } from "./recruiter-component-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule, NgbNavModule, } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ModalModule } from "ngx-bootstrap/modal";
// import { PaginationModule } from "ngx-bootstrap/pagination";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxSpinnerModule } from "ngx-spinner";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMaskModule } from "ngx-mask";
import { InterceptorService } from "../services/interceptor.service";
import { DataSharingService } from "../services/data.share.service";
import { CommonRecuriterComponent } from "../shared/common-recuriter";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { JobPostComponent } from "./job-post/job-post.component";
import { AddPostComponent } from "./job-post/add-post/add-post.component";
import { PostJobComponent } from "./job-post/post-job/post-job.component";
import { DetailsComponent } from "./job-post/details/details.component";
import { SearchComponent } from "./search/search.component";
import { UsersComponent } from "./users/users.component";

import { NgxPaginationModule } from "ngx-pagination";
import { JobTemplateComponent } from "./job-post/job-template/job-template.component"
import { UserDetailComponent } from "./users/user-detail/user-detail.component";
import { AddEditUserComponent } from "./users/add-edit-user/add-edit-user.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { StepOneComponent } from "./job-post/add-post/step-one/step-one.component";
import { StepTwoComponent } from "./job-post/add-post/step-two/step-two.component";
import { StepThreeComponent } from "./job-post/add-post/step-three/step-three.component";
import { StepFourComponent } from "./job-post/add-post/step-four/step-four.component";
import { StepFiveComponent } from "./job-post/add-post/step-five/step-five.component";
import { PreviewComponent } from "./job-post/add-post/preview/preview.component";
import { CapitalizeFirstDirective } from "../directive/capitalize-first.directive";
import { SuggestedJobComponent } from "./job-post/suggested-job/suggested-job.component";
import { ApplicantJobComponent } from "./job-post/applicant-job/applicant-job.component";
import { MessageComponent } from "./message/message.component";
import { GroupsComponent } from "./groups/groups.component";
import { AddGroupComponent } from "./groups/add-group/add-group.component";
import { ManageUsersComponent } from "./groups/manage-users/manage-users.component";
import { AddUsersGroupComponent } from "./groups/add-users-group/add-users-group.component";
import { DetailComponent } from "./job-post/applicant-job/detail/detail.component";
import { NotesComponent } from "./job-post/applicant-job/notes/notes.component";
import { ActivityComponent } from "./job-post/applicant-job/activity/activity.component";
import { MessageDetailComponent } from "./message/message-detail/message-detail.component";
import { DateDifference } from "../pipe/date-difference.pipe";
import { ArchivedComponent } from "./users/archived/archived.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { CandidatesComponent } from "./candidates/candidates.component";
import { SkippedComponent } from "./candidates/skipped/skipped.component";
import { SaveSearchComponent } from "./search/save-search/save-search.component";
import { ProfileComponent } from "./profile/profile.component";
import { AccountSettingsComponent } from "./account-settings/account-settings.component";
import { ChangePasswordComponent } from "./account-settings/change-password/change-password.component";
import { NotificationComponent } from "./account-settings/notification/notification.component";
import { SaveCardComponent } from "./account-settings/save-card/save-card.component";
import { SubscriptionComponent } from "./account-settings/subscription/subscription.component";
import { BillingAddressComponent } from "./account-settings/billing-address/billing-address.component";
import { MyTemplatesComponent } from "./account-settings/my-templates/my-templates.component";
import { InventoryHistoryComponent } from "./account-settings/inventory-history/inventory-history.component";
import { RecruiterChatFilterPipe } from "../pipe/recruiter-messages/recruiter-chat-filter.pipe";
import { RecruiterMessageGroupbyPipe } from "../pipe/recruiter-messages/recruiter-message-groupby.pipe";
import { DateAgoConvertPipe } from "../pipe/recruiter-messages/date-ago-convert.pipe";
import { InventoryPlanComponent } from "./account-settings/inventory-history/inventory-plan/inventory-plan.component";
import { SubscriptionPlanComponent } from "./account-settings/subscription/subscription-plan/subscription-plan.component";
import { CheckoutComponent } from "./account-settings/checkout/checkout.component";
import { ShareButtonComponent } from "./job-post/applicant-job/share-button/share-button.component";
import { NotificationManagementComponent } from "./notification-management/notification-management.component";
import { ReportsComponent } from "./reports/reports.component";
import { SearchDetailComponent } from "./search/search-detail/search-detail.component";
import { SearchNotesComponent } from "./search/search-notes/search-notes.component";
import { SearchAcitivityComponent } from "./search/search-acitivity/search-acitivity.component";
import { EditComponent } from "./profile/edit/edit.component";
import { UploadFileComponent } from "./upload-files/upload-file.component";

import { NgxEchartsModule } from "ngx-echarts";
import * as echarts from "echarts";
import { SerachReportComponent } from "./reports/serach-report/serach-report.component";
import { InventoryUsageComponent } from "./reports/inventory-usage/inventory-usage.component";
import { JobReportComponent } from "./reports/job-report/job-report.component";
import { UserActivityComponent } from "./reports/user-activity/user-activity.component";
import { HelpComponent } from "./help/help.component";
import { ShareModule } from "../shared/shared.module";
import { ConfirmationScreenComponent } from "./confirmation-screen/confirmation-screen.component";
import { InventoryServiceService } from "./confirmation-screen/inventory-service.service";

@NgModule({
  declarations: [
    CommonRecuriterComponent,
    UploadFileComponent,
    DashboardComponent,
    JobPostComponent,
    SearchComponent,
    UsersComponent,
    AddPostComponent,
    PostJobComponent,
    DetailsComponent,
    JobTemplateComponent,
    UserDetailComponent,
    AddEditUserComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponent,
    StepFiveComponent,
    PreviewComponent,
    SuggestedJobComponent,
    ApplicantJobComponent,
    MessageComponent,
    GroupsComponent,
    AddGroupComponent,
    ManageUsersComponent,
    AddUsersGroupComponent,
    DetailComponent,
    NotesComponent,
    ActivityComponent,
    CapitalizeFirstDirective,
    MessageDetailComponent,
    // CapitalizeFirstDirective
    DateDifference,
    ArchivedComponent,
    CandidatesComponent,
    SkippedComponent,
    SaveSearchComponent,
    ProfileComponent,
    AccountSettingsComponent,
    ChangePasswordComponent,
    NotificationComponent,
    SaveCardComponent,
    SubscriptionComponent,
    BillingAddressComponent,
    MyTemplatesComponent,
    InventoryHistoryComponent,

    RecruiterChatFilterPipe,
    RecruiterMessageGroupbyPipe,
    DateAgoConvertPipe,
    InventoryPlanComponent,
    SubscriptionPlanComponent,
    CheckoutComponent,
    ShareButtonComponent,
    NotificationManagementComponent,
    ReportsComponent,
    SearchDetailComponent,
    SearchNotesComponent,
    SearchAcitivityComponent,
    EditComponent,
    SerachReportComponent,
    InventoryUsageComponent,
    JobReportComponent,
    UserActivityComponent,
    HelpComponent,
    ConfirmationScreenComponent,
    
  ],
  imports: [ShareModule,
    NgxStripeModule.forRoot("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"),
    RouterModule,
    CommonModule,
    RecruiterComponentRoutingModule,
    FormsModule,
    CommonModule,
    NgbModule,
    NgbNavModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    // PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxSpinnerModule,
    ImageCropperModule,
    NgxMaskModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    InfiniteScrollModule,

    NgxEchartsModule.forRoot({
      echarts
    }),
  ],
  exports: [
    NgxStripeModule
  ],
  providers: [
    AsyncPipe,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    NgxSpinnerModule,
    DataSharingService,
    InventoryServiceService
  ],
  bootstrap: []
})
export class RecruiterComponentsModule { }
